<div class="ais-RefinementList">
  <div>
    <!-- this div is here to simulate the ng-ais-header container -->
    <button
      class="ais-RefinementList-header ais-header"
      [ngClass]="{'ais-RefinementList-header--closed': !showRefinementBody}"
      (click)="toggleShowBody()"
    >
      <span *ngIf="options.label === 'CATALOG.FILTERS.SIZE.1'" i18n="@@CATALOG.FILTERS.SIZE.1">Women’s Size</span>
      <span *ngIf="options.label === 'CATALOG.FILTERS.SIZE.2'" i18n="@@CATALOG.FILTERS.SIZE.2">Jean size</span>
      <span *ngIf="options.label === 'CATALOG.FILTERS.SIZE.3'" i18n="@@CATALOG.FILTERS.SIZE.3">Women’s shoe size</span>
      <span *ngIf="options.label === 'CATALOG.FILTERS.SIZE.4'" i18n="@@CATALOG.FILTERS.SIZE.4">Men’s shoe size</span>
      <span *ngIf="options.label === 'CATALOG.FILTERS.SIZE.5'" i18n="@@CATALOG.FILTERS.SIZE.5">Jean size</span>
      <span *ngIf="options.label === 'CATALOG.FILTERS.SIZE.6'" i18n="@@CATALOG.FILTERS.SIZE.6">Child’s shoe size</span>
      <span *ngIf="options.label === 'CATALOG.FILTERS.SIZE.7'" i18n="@@CATALOG.FILTERS.SIZE.7">Accessories size</span>
      <span *ngIf="options.label === 'CATALOG.FILTERS.SIZE.8'" i18n="@@CATALOG.FILTERS.SIZE.8">Bra-top size</span>
      <span *ngIf="options.label === 'CATALOG.FILTERS.SIZE.9'" i18n="@@CATALOG.FILTERS.SIZE.9">Accessories size</span>
      <span *ngIf="options.label === 'CATALOG.FILTERS.SIZE.10'" i18n="@@CATALOG.FILTERS.SIZE.10">Men’s size</span>
      <span *ngIf="options.label === 'CATALOG.FILTERS.SIZE.11'" i18n="@@CATALOG.FILTERS.SIZE.11">Child’s size</span>
      <span *ngIf="options.label === 'CATALOG.FILTERS.SIZE.12'" i18n="@@CATALOG.FILTERS.SIZE.12"
        >Waist measurement</span
      >
      <span *ngIf="options.label === 'CATALOG.FILTERS.SIZE.13'" i18n="@@CATALOG.FILTERS.SIZE.13">Glove size</span>
      <span *ngIf="options.label === 'CATALOG.FILTERS.SIZE.14'" i18n="@@CATALOG.FILTERS.SIZE.14">Hat size</span>
      <span *ngIf="options.label === 'CATALOG.FILTERS.SIZE.15'" i18n="@@CATALOG.FILTERS.SIZE.15">Ring size</span>
      <span *ngIf="options.label === 'CATALOG.FILTERS.SIZE.16'" i18n="@@CATALOG.FILTERS.SIZE.16"
        >Waist measurement</span
      >
      <span *ngIf="options.label === 'CATALOG.FILTERS.SIZE.17'" i18n="@@CATALOG.FILTERS.SIZE.17">Glove size</span>
      <span *ngIf="options.label === 'CATALOG.FILTERS.SIZE.18'" i18n="@@CATALOG.FILTERS.SIZE.18">Hat size</span>
      <span *ngIf="options.label === 'CATALOG.FILTERS.SIZE.19'" i18n="@@CATALOG.FILTERS.SIZE.19">Suit size</span>
      <span *ngIf="options.label === 'CATALOG.FILTERS.SIZE.20'" i18n="@@CATALOG.FILTERS.SIZE.20">Shirt size</span>
      <span *ngIf="options.label === 'CATALOG.FILTERS.SIZE.21'" i18n="@@CATALOG.FILTERS.SIZE.21">Pants size</span>
      <span *ngIf="options.label === 'CATALOG.FILTERS.SIZE.22'" i18n="@@CATALOG.FILTERS.SIZE.22">Swimwear size</span>
      <span *ngIf="options.label === 'CATALOG.FILTERS.SIZE.23'" i18n="@@CATALOG.FILTERS.SIZE.23">Polo size</span>
      <span *ngIf="options.label === 'CATALOG.FILTERS.SIZE.24'" i18n="@@CATALOG.FILTERS.SIZE.24">T-shirt size</span>
      <span *ngIf="options.label === 'CATALOG.FILTERS.SIZE.25'" i18n="@@CATALOG.FILTERS.SIZE.25">Top size</span>
    </button>
  </div>
  <div class="ais-RefinementList-body ais-body" [ngStyle]="{display: showRefinementBody ? 'block' : 'none'}">
    <ul class="ais-RefinementList-list filtersShortCheckboxList">
      <li *ngFor="let item of items | appSortByNumber" class="filtersShortCheckbox">
        <input
          id="{{ item.value }}"
          class="filtersShortCheckbox__input"
          type="checkbox"
          (change)="refine($event, item)"
          [attr.checked]="item.isRefined ? 'checked' : null"
        />
        <label for="{{ item.value }}" class="filtersShortCheckbox__label">{{ item.label }}</label>
        <div class="filtersShortCheckbox__tooltip">
          {{ item.label }} <span class="filtersShortCheckbox__tooltip__count">({{ item.count }})</span>
        </div>
      </li>
    </ul>
  </div>
</div>
